/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/HowToPlayPopup',['lodash', 'pixi', 'absolute/coords', 'absolute/screenmetrics', 'absolute/stringmanager',
		'MenuUI/MsftButton', 'MenuUI/MsftToggleButton', 'absolute/textutils', 'absolute', 'MenuUI/ControlFocusManager',
		'util/CustomWordWrapper', 'Managers/ScaleManager'],
	function (_, PIXI, Coords, ScreenMetrics, _s, MsftButton, MsftToggleButton, TextUtils,
	          Absolute, ControlFocusManager, CustomWordWrapper, ScaleManager) {
		var HowToPlayPopup = function (config, ui) {
			var defaultConfig = {
				text: '',
				gameMode: 'klondike',
				letterStyle: {
					font: ScreenMetrics.getResScale() * 25 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left'
				},
				letterStyleTitle: {
					font: ScreenMetrics.getResScale() * 30 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left'
				},
				indicatorLetterStyle: {
					font: ScreenMetrics.getResScale() * 20 + "px Arial",
					fontFamily: 'segoe',
					fill: '#ffffff',
					align: 'left'
				},
				width: Coords.x(1036),
				height: Coords.y(280),
				largeWidth: Coords.x(634),
				largeHeight: Coords.x(356),
				buttonWidth: Coords.x(172),
				buttonHeight: Coords.y(54),
				headline: 'titles.howToPlay',
				threeSliceOptions: {
					multistate: true,
					images: {
						left: 'MS_3slice_btn_black_01.png',
						center: 'MS_3slice_btn_black_02.png',
						right: 'MS_3slice_btn_black_03.png'
					}
				},
				onClose: function () {
				},
				onToggleAlerts: function () {
				}
			};
			this.init(_.extend(defaultConfig, config), ui);
		};
		HowToPlayPopup.constuctor = HowToPlayPopup;
		HowToPlayPopup.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		HowToPlayPopup.prototype.init = function (config, ui) {
			PIXI.DisplayObjectContainer.call(this);
			this.config = config;
			this.ui = ui;
			this.layoutType = ScaleManager.scaleFactorX < 0.45 ? 'large' : 'small';
			this.overlay = null;
			this.background = null;
			this.title = null;
			this.bodyText = null;
			this.nextButton = null;
			this.backButton = null;
			this.closeButton = null;
			this.playButton = null;
			this.doNotShowButton = null;
			this.pageIndicator = null;
			this.isTweening = true;

			this.bodyLabels = [];
			this.bodyTexts = [];
			this.instructions = _s('howToPlay.' + this.config.gameMode, null, true);
			this.pageIndex = 0;
			this.controlFocusManager = new ControlFocusManager();
			this.initOverlay();
			this.initPageContainer();
			this.initBackground();
			this.initTitle();
			this.initBodyLabels();
			this.initBodyTexts();
			this.initButtons();
			this.initDoNotShowButton();
			this.initControlFocusManager();
			this.initPageIndicator();
			//Scaling
			this.initForceScaleSprite();
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});

			this.repositionPageContainer();
			this.open();
		};

		HowToPlayPopup.prototype.initForceScaleSprite = function () {
			if (this.forceScaleSprite) this.removeChild(this.forceScaleSprite);
			this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
			this.forceOffsetX = Absolute.Coords.x(10);
			this.forceOffsetY = Absolute.Coords.y(10);
			this.forceScaleSprite.width = this.layoutType === 'small' ? this.config.width : this.config.largeWidth;
			this.forceScaleSprite.height = this.layoutType === 'small' ? this.config.height : this.config.largeHeight;
			this.forceScaleSprite.alpha = 0;
			this.addChild(this.forceScaleSprite);
		};

		HowToPlayPopup.prototype.handleResize = function () {
			if (this.parent) this.updateTransform();
			var layoutType = ScaleManager.scaleFactorX < 0.45 ? 'large' : 'small';
			this.checkAndChangeLayout(layoutType);
			var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
			this.pageContainer.scale.set(1, 1);
			var initialWidth = this.pageContainer.width, initialHeight = this.pageContainer.height;
			this.pageContainer.scale.set(oldScaleX, oldScaleY);
			var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
				screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
				roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
			this.pageContainer.width = initialWidth * screenScaleX;
			this.pageContainer.height = initialHeight * screenScaleY;
			var realWidth = this.pageContainer.width / screenScaleX,
				realHeight = this.pageContainer.height / screenScaleY;
			var widthToShow = initialWidth, heightToShow = initialHeight;
			var tookCare = false;
			if (realWidth > roomWidth) {
				this.pageContainer.width = Absolute.Coords.x(1920);
				var delta = roomWidth / widthToShow;
				this.pageContainer.height = ((initialHeight * screenScaleY) * delta);
				if ((this.pageContainer.height / screenScaleY) > roomHeight) {
					this.pageContainer.height = Absolute.Coords.y(1080);
					var delta = roomHeight / heightToShow;
					this.pageContainer.width = ((initialWidth * screenScaleX) * delta);
				}
				tookCare = true;
			}
			if (!tookCare && (realHeight > roomHeight)) {
				this.pageContainer.height = Absolute.Coords.y(1080);
				var delta = roomHeight / heightToShow;
				this.pageContainer.width = ((initialWidth * screenScaleX) * delta);
				if ((this.pageContainer.width / screenScaleX) > roomWidth) {
					this.pageContainer.width = Absolute.Coords.x(1920);
					var delta = roomWidth / widthToShow;
					this.pageContainer.height = ((initialHeight * screenScaleY) * delta);
				}
			}
			if (!this.isTweening) {
				this.pageContainer.x = (Absolute.Coords.x(1920) * .5) - (this.pageContainer.width / 2) + this.forceOffsetX;
				this.pageContainer.y = (Absolute.Coords.y(1080) * .5) - (this.pageContainer.height / 2) + this.forceOffsetY;
			}
		};

		HowToPlayPopup.prototype.initOverlay = function () {
			if (this.overlay) this.removeChild(this.overlay);
			var overlay = new PIXI.Graphics();
			overlay.beginFill(0, 0.3);
			overlay.drawRect(0, 0, this.ui.width, this.ui.height);
			overlay.endFill();
			overlay.interactive = true;
			overlay.buttonMode = false;
			overlay.hitArea = new PIXI.Rectangle(0, 0, this.ui.width, this.ui.height);
			Absolute.SpriteUtils.bindInteraction(overlay, function (event) {
			}.bind(this));
			overlay.mouseup = function () {
			};
			this.addChild(overlay);
			this.overlay = overlay;
		};

		HowToPlayPopup.prototype.initPageContainer = function () {
			this.pageContainer = new PIXI.DisplayObjectContainer();
			this.addChild(this.pageContainer);
		};

		HowToPlayPopup.prototype.initBackground = function () {
			var backgroundWidth = this.layoutType === 'small' ? this.config.width : this.config.largeWidth;
			var backgroundHeight = this.layoutType === 'small' ? this.config.height : this.config.largeHeight;
			if (this.background) this.pageContainer.removeChild(this.background);
			var background = new PIXI.Graphics();
			background.beginFill(0);
			background.drawRect(0, 0, backgroundWidth, backgroundHeight);
			background.endFill();
			this.pageContainer.addChild(background);
			this.background = background;
		};

		HowToPlayPopup.prototype.initTitle = function () {
			if (this.title) this.pageContainer.removeChild(this.headline);
			var title = new PIXI.Text(
				_s(this.config.headline || this.instructions[0].headline), this.config.letterStyleTitle
			);
			title.x = Absolute.Coords.x(20);
			title.y = Absolute.Coords.x(15);
			this.title = title;
			this.pageContainer.addChild(title);
		};

		HowToPlayPopup.prototype.initBodyLabels = function (page) {
			var fueInstructions = this.instructions.filter(function (instruction) {
				return instruction.id.indexOf('fue') !== -1 || instruction.fue;
			});
			fueInstructions.forEach(function (instruction) {
				this.bodyLabels.push(instruction.description);
			}.bind(this));

		};

		HowToPlayPopup.prototype.initBodyTexts = function () {
			if (this.bodyText) this.pageContainer.removeChild(this.bodyText);
			this.bodyLabels.forEach(function (label) {
				var text = new PIXI.Text(label, this.config.letterStyle);
				text.x = Absolute.Coords.x(20);
				text.y = this.title.height + Absolute.Coords.y(26);
				text.visible = false;
				this.bodyTexts.push(text);
				this.pageContainer.addChild(text);
			}.bind(this));
			this.bodyText = this.bodyTexts[this.pageIndex];
			this.bodyText.visible = true;
			this.wrapBodyText();
		};

		HowToPlayPopup.prototype.initButtons = function () {
			this.initNextButton();
			this.initPlayButton();
			this.initBackButton();
			this.initCloseButton();
			this.initDoNotShowButton();
			this.initControlFocusManager();
			this.updateButtons();
		};

		HowToPlayPopup.prototype.initNextButton = function () {
			if (this.nextButton) this.pageContainer.removeChild(this.nextButton);
			var nextButton = this.buildButton(
				this.handlePageChanged.bind(this, true),
				_s('buttons.next')
			);
			nextButton.x = this.pageContainer.width - nextButton.width - Coords.x(20);
			nextButton.y = this.pageContainer.y + this.pageContainer.height - nextButton.height - Absolute.Coords.x(20) * ScaleManager.scaleFactorX;
			this.pageContainer.addChild(nextButton);
			this.nextButton = nextButton;
		};

		HowToPlayPopup.prototype.initPlayButton = function () {
			if (this.playButton) this.pageContainer.removeChild(this.playButton);
			var playButton = this.buildButton(
				this.closePopup.bind(this),
				_s('buttons.play')
			);
			playButton.x = this.nextButton.x;
			playButton.y = this.nextButton.y;
			playButton.visible = false;
			this.pageContainer.addChild(playButton);
			this.playButton = playButton;
		};

		HowToPlayPopup.prototype.initBackButton = function () {
			if (this.backButton) this.pageContainer.removeChild(this.backButton);
			var backButton = this.buildButton(
				this.handlePageChanged.bind(this, false),
				_s('buttons.back')
			);
			backButton.x = this.nextButton.x - this.nextButton.width - Absolute.Coords.x(10) * ScaleManager.scaleFactorX;
			backButton.y = this.nextButton.y;
			backButton.visible = false;
			this.pageContainer.addChild(backButton);
			this.backButton = backButton;
		};

		HowToPlayPopup.prototype.initCloseButton = function () {
			if (this.closeButton) this.pageContainer.removeChild(this.closeButton);
			var closeButton = this.buildButton(
				this.closePopup.bind(this),
				_s('buttons.close')
			);
			var buttonAfter = this.backButton.visible ? this.backButton : this.nextButton;
			closeButton.x = buttonAfter.x - buttonAfter.width - Absolute.Coords.x(10) * ScaleManager.scaleFactorX;
			closeButton.y = this.nextButton.y;
			this.pageContainer.addChild(closeButton);
			this.closeButton = closeButton;
		};

		HowToPlayPopup.prototype.initDoNotShowButton = function () {
			if (this.doNotShowButton) this.pageContainer.removeChild(this.doNotShowButton);
			var doNotShowButton = new MsftToggleButton(
				{
					action: function (prefix, key, value) {
						this.config.onToggleAlerts(!value);
					}.bind(this),
					settingPrefix: "general",
					settingsKey: "showAlerts",
					text: '',
					setting: false,
					letterStyle: {
						font: "bold " + ScreenMetrics.getResScale() * 20 + "px Arial",
						fontFamily: 'segoe',
						fill: '#ffffff',
						align: 'left'
					},
					toggleOff: 'checkbox_off.png',
					toggleOn: 'checkbox_on.png',
					onLabel: 'buttons.doNotShowAgain',
					offLabel: 'buttons.doNotShowAgain',
					toggleDot: 'noDot'
				}
			);
			var posY = this.layoutType === 'small' ?
				this.pageContainer.height - doNotShowButton.height - Absolute.Coords.x(20) * ScaleManager.scaleFactorX
				: this.nextButton.y - doNotShowButton.height - Absolute.Coords.x(10) * ScaleManager.scaleFactorX;
			doNotShowButton.x = Absolute.Coords.x(20);
			doNotShowButton.y = posY;
			this.pageContainer.addChild(doNotShowButton);
			this.doNotShowButton = doNotShowButton;
		};

		HowToPlayPopup.prototype.initControlFocusManager = function () {
			this.controlFocusManager.addControl(this.playButton, false, null, 3);
			this.controlFocusManager.addControl(this.doNotShowButton, true, null, 0);
			this.controlFocusManager.addControl(this.closeButton, true, null, 1);
			this.controlFocusManager.addControl(this.backButton, false, null, 2);
			this.controlFocusManager.addControl(this.nextButton, true, null, 3);
			this.updateButtons();
		};

		HowToPlayPopup.prototype.initPageIndicator = function () {
			if (this.pageIndicator) this.pageContainer.removeChild(this.pageIndicator);
			this.pageIndicator = new PIXI.Text('', this.config.indicatorLetterStyle);
			this.pageContainer.addChild(this.pageIndicator);
			this.updatePageIndicator();
		};

		HowToPlayPopup.prototype.repositionPageContainer = function () {
			this.pageContainer.updateTransform();
			this.pageContainer.x = -this.background.width;
			this.pageContainer.y = (Absolute.Coords.x(1080) * .5) - (this.pageContainer.height / 2) + this.forceOffsetY
		};

		HowToPlayPopup.prototype.checkAndChangeLayout = function (layoutType) {
			if (this.layoutType === layoutType) return;
			this.removePageContainer();
			this.layoutType = layoutType;
			this.bodyTexts = [];
			this.addChild(this.pageContainer);
			this.initBackground();
			this.initTitle();
			this.initBodyTexts();
			this.initButtons();
			this.initPageIndicator();
			this.initForceScaleSprite();
			this.handleResize();
			this.repositionPageContainer();
		};

		HowToPlayPopup.prototype.removePageContainer = function () {
			if (!this.pageContainer || !this.pageContainer.children) return;
			this.pageContainer.children.forEach(function (child) {
				child.parent.removeChild(child);
			});
			this.pageContainer.parent.removeChild(this.pageContainer);
			this.pageContainer = null;
			this.pageContainer = new PIXI.DisplayObjectContainer();
		};

		HowToPlayPopup.prototype.open = function () {
			var self = this;
			var endX = (Absolute.Coords.x(1920) * .5) - (this.pageContainer.width / 2) + this.forceOffsetX;
			var openTween = new TWEEN.Tween({x: this.pageContainer.x})
				.to({x: endX}, 500)
				.easing(TWEEN.Easing.Cubic.Out)
				.onUpdate(function () {
					self.pageContainer.x = this.x;
				})
				.onComplete(function () {
					TWEEN.remove(openTween);
					this.controlFocusManager.focusCurrentControl();
					this.isTweening = false;
				}.bind(this))
				.start();
		};

		HowToPlayPopup.prototype.closePopup = function () {
			var self = this;
			var endX = -this.pageContainer.width;
			var closeTween = new TWEEN.Tween({x: this.pageContainer.x})
				.to({x: endX}, 500)
				.easing(TWEEN.Easing.Cubic.Out)
				.onUpdate(function () {
					self.pageContainer.x = this.x;
				})
				.onComplete(function () {
					if (typeof self.config.onClose == 'function') {
						self.config.onClose();
					}
					this.visible = false;
					this.isTweening = false;
					TWEEN.remove(closeTween);
				}.bind(this))
				.start();
		};

		HowToPlayPopup.prototype.removeScaling = function () {
			ScaleManager.removeElement(this);
		};

		HowToPlayPopup.prototype.wrapBodyText = function () {
			this.bodyText.style.wordWrap = true;
			this.bodyText.style.wordWrapWidth = this.background.width - Absolute.Coords.x(80);
			CustomWordWrapper.doTextCustomWrap(
				this.bodyText, _s.extractNumbersFromString(this.config.letterStyle.font),
				'', this.bodyText.style.wordWrapWidth, this.background.height * 0.4
			);
		};

		HowToPlayPopup.prototype.updatePageIndicator = function () {
			this.pageIndicator.setText((this.pageIndex + 1).toString() + ' ' + _s('of') + ' ' + this.bodyLabels.length.toString());
			this.pageIndicator.x = this.background.width - this.pageIndicator.width - Coords.x(20);
			this.pageIndicator.y = Absolute.Coords.x(15)
		};

		HowToPlayPopup.prototype.handlePageChanged = function (isForward) {
			this.bodyText.visible = false;
			this.pageIndex += isForward ? 1 : -1;
			this.pageIndex = Math.max(0, this.pageIndex);
			this.pageIndex = Math.min(this.bodyLabels.length - 1, this.pageIndex);
			this.bodyText = this.bodyTexts[this.pageIndex];
			this.bodyText.visible = true;
			this.updateButtons();
			this.updatePageIndicator();
			this.wrapBodyText();
		};

		HowToPlayPopup.prototype.updateButtons = function () {
			this.controlFocusManager.unfocusCurrentControl();
			this.nextButton.visible = this.pageIndex !== this.bodyLabels.length - 1;
			this.playButton.visible = this.pageIndex === this.bodyLabels.length - 1;
			this.backButton.visible = this.pageIndex > 0;
			this.closeButton.visible = this.pageIndex !== this.bodyLabels.length - 1;
			this.updateButtonsPositions();
			this.updateControlFocuseManager();
		};

		HowToPlayPopup.prototype.updateControlFocuseManager = function () {
			this.controlFocusManager.setControlActive(this.playButton, this.playButton.visible);
			this.controlFocusManager.setControlActive(this.nextButton, this.nextButton.visible);
			this.controlFocusManager.setControlActive(this.backButton, this.backButton.visible);
			this.controlFocusManager.setControlActive(this.closeButton, this.closeButton.visible);
			this.controlFocusManager.sortActives();
			this.controlFocusManager.focusCurrentControl();
		};

		HowToPlayPopup.prototype.updateButtonsPositions = function () {
			this.nextButton.x = this.background.width - this.nextButton.width - Coords.x(20);
			var buttonAfter = this.backButton.visible ? this.backButton : this.nextButton;
			this.closeButton.x = buttonAfter.x - buttonAfter.width - Absolute.Coords.x(10) * ScaleManager.scaleFactorX;
			this.backButton.x = this.nextButton.x - this.nextButton.width - Absolute.Coords.x(10) * ScaleManager.scaleFactorX;
		};

		HowToPlayPopup.prototype.buildButton = function (onClickHandler, label) {
			var button = new MsftButton({
				action: onClickHandler,
				text: label,
				width: this.config.buttonWidth,
				minHeight: this.config.buttonHeight,
				letterStyle: this.config.letterStyle,
				threeSlice: this.config.threeSliceOptions
			});
			return button;
		};

		HowToPlayPopup.prototype.handleCommand = function (command) {
			switch (command) {
				case 'Tab':
				case 'Right':
					this.controlFocusManager.focusNextControl(1);
					break;
				case 'ShiftTab':
				case 'Left':
					this.controlFocusManager.focusNextControl(-1);
					break;
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;

			}
		};

		return HowToPlayPopup;
	});

